/* eslint-disable @typescript-eslint/no-explicit-any */
import { ComponentType } from 'react'

export const retry = <T = { default: ComponentType<any> },>(
  fn: () => Promise<T>,
  retriesLeft = 2,
  interval = 1000,
  reloadOnFailure = true
): Promise<T> => {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            if (reloadOnFailure) window.location.reload()
            else reject(error)
            return
          }

          // Passing on "reject" is the important part
          retry(fn, retriesLeft - 1, interval, reloadOnFailure).then(resolve, reject)
        }, interval)
      })
  })
}

export function flatMapLineItems(lineItem: ILineItem): ILineItem[] {
  return lineItem.sub_items.length > 0 ? lineItem.sub_items.flatMap(flatMapLineItems) : [lineItem]
}

export const getBaseRoutePath = (path: string) => `${path}/*`
